import styled from "styled-components";
import { Box } from '@mui/material';

export const TopToolbarMarketingActions = styled.div`
  display: flex;
  gap: 8px;
  padding: 8px;
`;

export const TableWrapper = styled.div`
  height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
`;

// Campaign Card Styles
export const CampaignCardWrapper = styled.div`
  padding: 24px;
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  margin-bottom: 16px;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  .campaign-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 12px;
  }

  .campaign-title {
    font-size: 16px;
    font-weight: 500;
    color: #1A1A1A;
    margin-bottom: 4px;
  }

  .campaign-badges {
    display: flex;
    gap: 8px;
  }

  .campaign-description {
    color: #666666;
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 16px;
  }

  .campaign-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 16px;
    border-top: 1px solid #E0E0E0;
  }

  .campaign-info {
    color: #666666;
    font-size: 12px;
  }

  .campaign-actions {
    display: flex;
    gap: 8px;
    
    .MuiIconButton-root {
      padding: 8px;
      color: #666666;
      
      &:hover {
        background-color: #F5F5F5;
        color: #1976D2;
      }
    }
  }

  .unread-badge {
    position: absolute;
    top: -2px;
    right: -2px;
    background-color: #FF4D4F;
    color: white;
    border-radius: 10px;
    min-width: 20px;
    height: 20px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 6px;
  }
`;

// Conversation View Styles
export const ConversationViewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #FFFFFF;
`;

export const ConversationHeader = styled.div`
  padding: 16px 24px;
  background: #FFFFFF;
  border-bottom: 1px solid #E0E0E0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .header-left {
    display: flex;
    align-items: center;
    gap: 12px;

    h6 {
      font-size: 18px;
      font-weight: 500;
      color: #1A1A1A;
    }
  }

  .MuiIconButton-root {
    padding: 8px;
    color: #666666;
    
    &:hover {
      background-color: #F5F5F5;
    }
  }
`;

export const TabsContainer = styled.div`
  padding: 0 24px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #fff;

  .MuiTabs-root {
    min-height: 48px;
    
    .MuiTab-root {
      text-transform: none;
      font-weight: 500;
      min-height: 48px;
      padding: 0 16px;

      &.Mui-selected {
        color: #1976d2;
      }
    }
  }
`;

export const ConversationContent = styled.div`
  display: flex;
  height: calc(100vh - 64px);
  background: #FFFFFF;
`;

export const ConversationList = styled.div`
  width: 40%;
  border-right: 1px solid #E0E0E0;
  background: #FFFFFF;
  overflow-y: auto;

  .search-box {
    padding: 16px;
    border-bottom: 1px solid #E0E0E0;
    
    .MuiInputBase-root {
      background-color: #F5F5F5;
      border-radius: 8px;
      
      &:hover {
        background-color: #EEEEEE;
      }
      
      .MuiOutlinedInput-notchedOutline {
        border: none;
      }
      
      input {
        &::placeholder {
          color: #666666;
          opacity: 1;
          font-size: 14px;
        }
      }
    }
  }
`;

export const ConversationListItem = styled.div`
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #E0E0E0;
  background: ${props => props.selected ? '#F8F9FB' : '#FFFFFF'};
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    background: ${props => props.selected ? '#F8F9FB' : '#F5F6F8'};
  }

  &::before {
    content: '';
    position: absolute;
    left: 4px;
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${props => props.hasPending ? '#FF4D4D' : 'transparent'};
    transition: all 0.2s ease;
    box-shadow: ${props => props.hasPending ? '0 0 0 2px rgba(255, 77, 77, 0.2)' : 'none'};
    animation: ${props => props.hasPending ? 'pulse 2s infinite' : 'none'};
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(255, 77, 77, 0.4);
    }
    70% {
      box-shadow: 0 0 0 6px rgba(255, 77, 77, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(255, 77, 77, 0);
    }
  }

  .contact-name {
    font-size: 14px;
    font-weight: 500;
    color: #1A1A1A;
    margin-bottom: 4px;
    padding-left: ${props => props.hasPending ? '16px' : '0'};
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .preview {
    color: #666666;
    font-size: 13px;
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: ${props => props.hasPending ? '16px' : '0'};
  }

  .conversation-meta {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-left: ${props => props.hasPending ? '16px' : '0'};
    
    .timestamp {
      color: #666666;
      font-size: 11px;
    }
  }
`;

export const ChatArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  overflow: hidden;
  position: relative;

  .timeline-container {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
    scroll-behavior: smooth;
    height: calc(100% - 72px);

    .message-content {
      margin-bottom: 16px;
      
      &.agent-message {
        .message-body {
          background: #FFFFFF;
          border: 1px solid #E0E0E0;
          border-radius: 4px;
          padding: 12px;
          margin-left: 0;
          position: relative;
        }
        
        .message-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
          
          .sender-name {
            font-size: 14px;
            font-weight: 500;
            color: #333333;
          }
          
          .time-stamp {
            font-size: 12px;
            color: #666666;
          }
        }
      }
      
      &.user-message {
        .message-body {
          background: #F5F5F5;
          border-radius: 4px;
          padding: 12px;
          margin-right: 0;
        }
      }

      .message-body {
        font-size: 14px;
        line-height: 1.5;
        color: #333333;
      }
      
      &:last-child {
        margin-bottom: 24px;
      }

      .pending-approval {
        margin-top: 8px;
        padding-top: 8px;
        border-top: 1px solid #E0E0E0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        .status {
          font-size: 13px;
          font-weight: 500;
          color: #F59E0B;
        }
        
        .actions {
          display: flex;
          align-items: center;
          gap: 16px;
          
          button {
            display: inline-flex;
            align-items: center;
            font-size: 13px;
            font-weight: 500;
            padding: 6px 8px;
            border: none;
            background: transparent;
            border-radius: 4px;
            cursor: pointer;
            color: #1A1A1A;
            
            svg {
              width: 16px;
              height: 16px;
              margin-right: 4px;
            }
            
            &.edit-button {
              color: #1A1A1A;
              
              &:hover {
                background-color: #F5F5F5;
              }
            }
            
            &.decline-button {
              color: #DC2626;
              
              &:hover {
                background-color: #FEF2F2;
              }
            }
            
            &.approve-button {
              color: #059669;
              
              &:hover {
                background-color: #ECFDF5;
              }
            }
          }
        }
      }
    }
  }
`;

export const ContactHeader = styled.div`
  padding: 16px 24px;
  background: #FFFFFF;
  border-bottom: 1px solid #E0E0E0;

  .contact-info {
    h6 {
      font-size: 16px;
      font-weight: 500;
      color: #1A1A1A;
      margin-bottom: 4px;
    }

    .contact-details {
      color: #6B7280;
      font-size: 14px;
      
      span + span:before {
        content: "•";
        margin: 0 8px;
      }
    }
  }
`;

export const Badge = styled.span`
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  
  ${props => {
    if (props.variant === 'new' || props.variant === 'destructive') {
      return `
        background-color: #EF4444;
        color: white;
      `;
    }
    if (props.variant === 'priority' || props.variant === 'outline') {
      return `
        background-color: transparent;
        border: 1px solid #EF4444;
        color: #EF4444;
      `;
    }
    if (props.variant === 'secondary' || props.variant === 'closed') {
      return `
        background-color: #E5E7EB;
        color: #6B7280;
      `;
    }
    return `
      background-color: #E5E7EB;
      color: #6B7280;
    `;
  }}
`;

export const InboxBadgeWrapper = styled.div`
  position: relative;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: 4px;
  
  .badge {
    position: absolute;
    top: -6px;
    right: -6px;
    background-color: #ff4d4f;
    color: white;
    border-radius: 50%;
    min-width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    padding: 2px;
  }
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
    border-radius: 4px;
  }

  svg {
    color: #666;
    
    &:hover {
      color: #1976d2;
    }
  }
`;

export const ConversationDrawer = styled(Box)`
  height: 100vh;
  width: calc(100% - 72px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  right: 0;
  top: 0;
`;

export const tableStyles = {
  tableContainer: {
    sx: {
      maxHeight: 'calc(100vh - 280px)',
      overflow: 'auto',
      '& thead': {
        position: 'sticky',
        top: 0,
        backgroundColor: '#F2F2F2',
        zIndex: 2,
      },
    },
  },
  tablePaper: {
    elevation: 0,
    sx: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      borderRadius: '8px',
      border: '1px solid #e0e0e0',
      position: 'relative',
    },
  },
  topToolbar: {
    sx: {
      position: 'sticky',
      top: 0,
      backgroundColor: '#F2F2F2',
      zIndex: 3,
      borderBottom: '1px solid #e0e0e0',
    },
  },
  tableHead: {
    sx: {
      position: 'sticky',
      top: '64px',
      backgroundColor: '#F2F2F2',
      zIndex: 2,
      '& th': {
        position: 'sticky',
        backgroundColor: '#F2F2F2',
        borderBottom: '1px solid #e0e0e0',
      },
    },
  },
  tableHeadCell: {
    sx: {
      position: 'sticky',
      backgroundColor: '#F2F2F2',
      zIndex: 2,
      whiteSpace: 'nowrap',
      overflow: 'visible',
      textOverflow: 'unset',
      '& .MuiTableSortLabel-root': {
        width: '100%',
      },
    },
  },
  bottomToolbar: {
    sx: {
      position: 'sticky',
      bottom: 0,
      backgroundColor: 'white',
      zIndex: 2,
      borderTop: '1px solid #e0e0e0',
    },
  },
  searchField: {
    sx: {
      minWidth: '300px',
      m: '0.5rem',
    },
  },
  tableRow: (theme) => ({
    sx: {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }),
};

export const paginationProps = {
  rowsPerPageOptions: [10, 15, 20, 25, 30],
  showFirstButton: true,
  showLastButton: true,
  labelRowsPerPage: "Show",
  showRowsPerPage: true,
  variant: "outlined",
  shape: "rounded",
};

// Update the MessageTimelineContent component styling
export const MessageTimelineContentWrapper = styled.div`
  display: flex;
  margin-bottom: 16px;
  
  .message-container {
    flex: 1;
    
    .message-content {
      background: #FFFFFF;
      border: 1px solid #E0E0E0;
      border-radius: 4px;
      padding: 12px;
      
      .message-actions {
        margin-top: 8px;
        padding-top: 8px;
        border-top: 1px solid #E0E0E0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        .pending-label {
          font-size: 13px;
          font-weight: 500;
          color: #F59E0B;
        }
        
        .action-buttons {
          display: flex;
          align-items: center;
          gap: 16px;
          
          .MuiButtonBase-root {
            min-width: unset;
            padding: 6px 8px;
            font-size: 13px;
            font-weight: 500;
            text-transform: none;
            border-radius: 4px;
            
            &.edit {
              color: #1A1A1A;
              background: transparent;
              
              &:hover {
                background-color: #F5F5F5;
              }
              
              .MuiSvgIcon-root {
                font-size: 16px;
                margin-right: 4px;
              }
            }
            
            &.decline {
              color: #DC2626;
              background: transparent;
              
              &:hover {
                background-color: #FEF2F2;
              }
              
              .MuiSvgIcon-root {
                font-size: 16px;
                margin-right: 4px;
              }
            }
            
            &.approve {
              color: #059669;
              background: transparent;
              
              &:hover {
                background-color: #ECFDF5;
              }
              
              .MuiSvgIcon-root {
                font-size: 16px;
                margin-right: 4px;
              }
            }
          }
        }
      }
    }
  }
`;

// Add specific styles for the Pending Approval section
export const PendingApprovalActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #E0E0E0;

  .pending-text {
    color: #F59E0B;
    font-size: 13px;
    font-weight: 500;
  }

  .actions {
    display: flex;
    align-items: center;
    gap: 16px;
  }
`;

export const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 6px 8px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  gap: 4px;

  svg {
    width: 14px;
    height: 14px;
  }

  ${props => {
    switch (props.action) {
      case 'edit':
        return `
          color: #666666;
          
          svg {
            path {
              stroke: #666666;
            }
          }
          
          &:hover { 
            background-color: #F5F5F5;
          }
        `;
      case 'approve':
        return `
          color: #16A34A;
          
          svg {
            path {
              stroke: #16A34A;
            }
          }
          
          &:hover { 
            background-color: #F0FDF4;
          }
        `;
      default:
        return '';
    }
  }}
`;
